<template>
    <a-modal
        :visible="visible"
        :title="'Metin Ayarları - ' + widget.title"
        width="90%"
        :footer="null"
        @cancel="$emit('close')"
        class="text-settings-modal"
        :destroyOnClose="true"
    >
        <a-form :form="form" layout="vertical">
            <div class="editor-container">
                <!-- Editör Araç Çubuğu -->
                <div class="editor-toolbar">
                    <div class="toolbar-group">
                        <a-tooltip :title="$t('table.bold')">
                            <a-button
                                :type="editor && editor.isActive('bold') ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleBold().run()"
                            >
                                <i class="material-icons">format_bold</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.italic')">
                            <a-button
                                :type="editor && editor.isActive('italic') ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleItalic().run()"
                            >
                                <i class="material-icons">format_italic</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.underline')">
                            <a-button
                                :type="editor && editor.isActive('underline') ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleUnderline().run()"
                            >
                                <i class="material-icons">format_underlined</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.strikethrough')">
                            <a-button
                                :type="editor && editor.isActive('strike') ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleStrike().run()"
                            >
                                <i class="material-icons">format_strikethrough</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.textColor')">
                            <a-button class="color-button">
                                <input 
                                    type="color" 
                                    class="color-input"
                                    @change="e => editor && editor.chain().focus().setColor(e.target.value).run()"
                                />
                                <i class="material-icons">format_color_text</i>
                            </a-button>
                        </a-tooltip>
                    </div>

                    <div class="toolbar-group">
                        <a-tooltip :title="$t('table.heading1')">
                            <a-button
                                :type="editor && editor.isActive('heading', { level: 1 }) ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleHeading({ level: 1 }).run()"
                            >
                                {{ $t("table.textEditorH1") }}
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.heading2')">
                            <a-button
                                :type="editor && editor.isActive('heading', { level: 2 }) ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleHeading({ level: 2 }).run()"
                            >
                                {{ $t("table.textEditorH2") }}
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.heading3')">
                            <a-button
                                :type="editor && editor.isActive('heading', { level: 3 }) ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleHeading({ level: 3 }).run()"
                            >
                                {{ $t("table.textEditorH3") }}
                            </a-button>
                        </a-tooltip>
                    </div>

                    <div class="toolbar-group">
                        <a-tooltip :title="$t('table.bulletList')">
                            <a-button
                                :type="editor && editor.isActive('bulletList') ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleBulletList().run()"
                            >
                                <i class="material-icons">format_list_bulleted</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.numberedList')">
                            <a-button
                                :type="editor && editor.isActive('orderedList') ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleOrderedList().run()"
                            >
                                <i class="material-icons">format_list_numbered</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.quote')">
                            <a-button
                                :type="editor && editor.isActive('blockquote') ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleBlockquote().run()"
                            >
                                <i class="material-icons">format_quote</i>
                            </a-button>
                        </a-tooltip>
                    </div>

                    <div class="toolbar-group">
                        <a-tooltip :title="$t('table.codeBlock')">
                            <a-button
                                :type="editor && editor.isActive('codeBlock') ? 'primary' : 'default'"
                                @click="editor && editor.chain().focus().toggleCodeBlock().run()"
                            >
                                <i class="material-icons">code</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.horizontalLine')">
                            <a-button @click="editor && editor.chain().focus().setHorizontalRule().run()">
                                <i class="material-icons">remove</i>
                            </a-button>
                        </a-tooltip>
                    </div>

                    <div class="toolbar-group">
                        <a-tooltip :title="$t('table.alignLeft')">
                            <a-button
                                :type="$_.get(previewSettings, 'textAlign') === 'left' ? 'primary' : 'default'"
                                @click="$_.set(previewSettings, 'textAlign', 'left')"
                            >
                                <i class="material-icons">format_align_left</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.alignCenter')">
                            <a-button
                                :type="$_.get(previewSettings, 'textAlign') === 'center' ? 'primary' : 'default'"
                                @click="$_.set(previewSettings, 'textAlign', 'center')"
                            >
                                <i class="material-icons">format_align_center</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.alignRight')">
                            <a-button
                                :type="$_.get(previewSettings, 'textAlign') === 'right' ? 'primary' : 'default'"
                                @click="$_.set(previewSettings, 'textAlign', 'right')"
                            >
                                <i class="material-icons">format_align_right</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.alignJustify')">
                            <a-button
                                :type="$_.get(previewSettings, 'textAlign') === 'justify' ? 'primary' : 'default'"
                                @click="$_.set(previewSettings, 'textAlign', 'justify')"
                            >
                                <i class="material-icons">format_align_justify</i>
                            </a-button>
                        </a-tooltip>
                    </div>

                    <div class="toolbar-group">
                        <a-tooltip :title="$t('table.undo')">
                            <a-button @click="editor && editor.chain().focus().undo().run()">
                                <i class="material-icons">undo</i>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip :title="$t('table.redo')">
                            <a-button @click="editor && editor.chain().focus().redo().run()">
                                <i class="material-icons">redo</i>
                            </a-button>
                        </a-tooltip>
                    </div>
                </div>

                <!-- Editör -->
                <div class="editor-content">
                    <editor-content :editor="editor" />
                </div>
            </div>

            <!-- Görünüm Ayarları -->
            <div class="appearance-settings">
                <a-form-item :label="$t('table.backgroundColor')">
                    <a-input type="color" v-model="previewSettings.backgroundColor" />
                </a-form-item>

                <a-form-item :label="$t('table.paddingPx')">
                    <a-slider
                        v-model="previewSettings.padding"
                        :min="0"
                        :max="48"
                        :step="4"
                    />
                </a-form-item>
            </div>

            <!-- Kaydet/İptal Butonları -->
            <div class="form-actions">
                <a-button @click="$emit('close')">{{ $t('table.cancel') }}</a-button>
                <a-button type="primary" @click="handleSave" :loading="saving">
                    {{ $t('table.save') }}
                </a-button>
            </div>
        </a-form>
    </a-modal>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import { Editor, EditorContent } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import Color from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import { VueRenderer } from "@tiptap/vue-2";
import tippy from "tippy.js";

export default Vue.extend({
    name: "TextSettingsModal",
    components: {
        EditorContent,
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        widget: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            editor: null,
            previewSettings: _.cloneDeep(this.widget.settings || {
                content: "",
                textAlign: "left",
                backgroundColor: "#ffffff",
                padding: 16,
            }),
            saving: false,
            selectedText: "",
            selectedRange: null,
            tooltipInstance: null,
        };
    },
    mounted() {
        this.initEditor();
    },
    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy();
        }
        if (this.tooltipInstance) {
            this.tooltipInstance.destroy();
        }
    },
    methods: {
        initEditor() {
            this.editor = new Editor({
                content: this.previewSettings.content,
                extensions: [
                    StarterKit,
                    Underline,
                    TextAlign.configure({
                        types: ["heading", "paragraph"],
                    }),
                    Link.configure({
                        openOnClick: false,
                    }),
                    Image,
                    TextStyle,
                    Color,
                ],
                onSelectionUpdate: ({ editor }) => {
                    const { from, to } = editor.state.selection;
                    if (from === to) {
                        if (this.tooltipInstance) {
                            this.tooltipInstance.hide();
                        }
                        return;
                    }

                    const selectedText = editor.state.doc.textBetween(from, to);
                    if (!selectedText) {
                        if (this.tooltipInstance) {
                            this.tooltipInstance.hide();
                        }
                        return;
                    }

                    this.selectedText = selectedText;
                    this.selectedRange = { from, to };

                    const selection = window.getSelection();
                    const range = selection.getRangeAt(0);
                    const rect = range.getBoundingClientRect();

                    if (!this.tooltipInstance) {
                        this.tooltipInstance = tippy(document.body, {
                            content: this.createTooltipContent(),
                            trigger: 'manual',
                            interactive: true,
                            placement: 'top',
                            theme: 'light',
                            arrow: true,
                        });
                    }

                    this.tooltipInstance.setProps({
                        getReferenceClientRect: () => rect
                    });
                    this.tooltipInstance.show();
                },
                onUpdate: ({ editor }) => {
                    this.previewSettings.content = editor.getHTML();
                },
            });
        },
        createTooltipContent() {
            const container = document.createElement('div');
            container.className = 'format-tooltip';

            // Kalın
            const boldBtn = document.createElement('button');
            boldBtn.innerHTML = '<i class="material-icons">format_bold</i>';
            boldBtn.onclick = () => this.editor.chain().focus().toggleBold().run();
            container.appendChild(boldBtn);

            // İtalik
            const italicBtn = document.createElement('button');
            italicBtn.innerHTML = '<i class="material-icons">format_italic</i>';
            italicBtn.onclick = () => this.editor.chain().focus().toggleItalic().run();
            container.appendChild(italicBtn);

            // Renk seçici
            const colorInput = document.createElement('input');
            colorInput.type = 'color';
            colorInput.onchange = (e) => this.editor.chain().focus().setColor(e.target.value).run();
            container.appendChild(colorInput);

            // Link
            const linkBtn = document.createElement('button');
            linkBtn.innerHTML = '<i class="material-icons">link</i>';
            linkBtn.onclick = () => {
                const url = prompt('URL giriniz:');
                if (url) {
                    this.editor.chain().focus().setLink({ href: url }).run();
                }
            };
            container.appendChild(linkBtn);

            return container;
        },
        async handleSave() {
            try {
                this.saving = true;
                await this.$emit("save", this.previewSettings);
            } catch (error) {
                console.error("Ayarlar kaydedilirken hata:", error);
                this.$message.error("Ayarlar kaydedilirken bir hata oluştu");
            } finally {
                this.saving = false;
            }
        },
    },
    watch: {
        visible(newValue) {
            if (newValue && !this.editor) {
                this.$nextTick(() => {
                    this.initEditor();
                });
            }
        },
    },
});
</script>

<style lang="scss">
.text-settings-modal {
    .editor-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        margin-bottom: 24px;

        .editor-toolbar {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            padding: 8px;
            border-bottom: 1px solid #e8e8e8;
            background: #fafafa;

            .toolbar-group {
                display: flex;
                gap: 4px;
                border-right: 1px solid #e8e8e8;
                padding-right: 8px;
                margin-right: 8px;

                &:last-child {
                    border-right: none;
                    padding-right: 0;
                    margin-right: 0;
                }

                .ant-btn {
                    padding: 0 8px;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .material-icons {
                        font-size: 18px;
                    }

                    &.color-button {
                        position: relative;
                        overflow: hidden;

                        .color-input {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            opacity: 0;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .editor-content {
            padding: 16px;
            min-height: 300px;
            max-height: 500px;
            overflow-y: auto;

            .ProseMirror {
                outline: none;
                min-height: 268px;

                > * + * {
                    margin-top: 0.75em;
                }

                ul,
                ol {
                    padding: 0 1rem;
                }

                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                    line-height: 1.1;
                }

                code {
                    background-color: rgba(#616161, 0.1);
                    color: #616161;
                }

                pre {
                    background: #0D0D0D;
                    color: #FFF;
                    font-family: "JetBrainsMono", monospace;
                    padding: 0.75rem 1rem;
                    border-radius: 0.5rem;

                    code {
                        color: inherit;
                        padding: 0;
                        background: none;
                        font-size: 0.8rem;
                    }
                }

                blockquote {
                    padding-left: 1rem;
                    border-left: 2px solid rgba(#0D0D0D, 0.1);
                }

                hr {
                    border: none;
                    border-top: 2px solid rgba(#0D0D0D, 0.1);
                    margin: 2rem 0;
                }
            }
        }
    }

    .appearance-settings {
        display: flex;
        gap: 24px;

        .ant-form-item {
            flex: 1;
            margin-bottom: 0;
        }
    }

    .form-actions {
        margin-top: 24px;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }

    // Tooltip styles
    :global(.format-tooltip) {
        display: flex;
        gap: 4px;
        padding: 4px;
        background: white;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

        button {
            background: none;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            padding: 4px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                background: #f5f5f5;
            }

            .material-icons {
                font-size: 16px;
            }
        }

        input[type="color"] {
            width: 24px;
            height: 24px;
            padding: 0;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            cursor: pointer;

            &::-webkit-color-swatch-wrapper {
                padding: 0;
            }
            &::-webkit-color-swatch {
                border: none;
                border-radius: 2px;
            }
        }
    }
}
</style> 